import { CAROUSEL_CARD_STYLES, Carousel } from '@components/primitives/Carousel'
import { Text } from '@components/primitives/Text'
import { type BackgroundColor } from '@lib/colors/colors'
import DynamicRoutes from '@lib/routes/DynamicRoutes'
import type { TrackingSources } from '@lib/tracking/TrackingSources'
import { type DirectoryForSummaryCard } from '@modules/directoryTopics/types/DirectoryForSummaryCard'
import { DirectoryLinkCard } from '../HomePage/ConditionCardSection/ConditionSectionCard'
import RelatedConditionCarouselClickWrapper from './RelatedConditionCarouselClickWrapper.client'

type DirectoryCardCarouselProps = {
  relatedDirectories: DirectoryForSummaryCard[]
  trackingSource: TrackingSources
}

const cardBg = [
  'bg-green200',
  'bg-blue200',
  'bg-warm200',
  'bg-turquoise200',
  'bg-success200',
  'bg-primary200',
] as BackgroundColor[]

const getDeterministicBackgroundColor = (index: number) =>
  cardBg[index % cardBg.length]!

/**
 * Render a carousel of cards that link to condition directories
 *
 */
export function RelatedConditionCarousel({
  relatedDirectories,
  trackingSource,
}: DirectoryCardCarouselProps) {
  const conditionCards = (relatedDirectories ?? []).map((directory, index) => {
    return {
      ...directory,
      backgroundColor: getDeterministicBackgroundColor(index),
    }
  })

  if (conditionCards.length < 1) {
    return null
  }

  return (
    <section id='related-directories'>
      <Text
        className='mb-4 text-neutral900'
        element={'h3'} // We want H3 for SEO, children should be most H4
        styleName='h4'
        value={'Popular Categories'}
      />
      <Carousel centerVertically={false} className='gap-4'>
        {conditionCards.map((card, _index) => (
          <RelatedConditionCarouselClickWrapper
            className={CAROUSEL_CARD_STYLES}
            key={card.primaryTitle}
            path={DynamicRoutes.topic(card.slug).toString()}
            source={trackingSource}
          >
            <DirectoryLinkCard
              backgroundColor={card.backgroundColor}
              className={CAROUSEL_CARD_STYLES}
              description={card.metaTitle}
              subtitle={card.primaryTitle.replace(/\[.*/, '')}
              url={DynamicRoutes.topic(card.slug)}
            />
          </RelatedConditionCarouselClickWrapper>
        ))}
      </Carousel>
    </section>
  )
}
